var _polygon, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0052B4"
    },
    d: "M512,256c0,141.384-114.616,256-256,256S0,397.384,0,256C0,256.061,256,0.028,256,0 C397.384,0,512,114.616,512,256z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M256,0c-0.016,0-0.028,0-0.043,0H256L256,0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M255.315,256H256c0-0.23,0-0.454,0-0.685C255.772,255.544,255.544,255.772,255.315,256z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M256,133.565C256,88.52,256,59.005,256,0h-0.043C114.591,0.024,0,114.629,0,256h133.565v-75.211 L208.776,256h46.54c0.228-0.228,0.456-0.456,0.685-0.685c0-17.247,0-32.636,0-46.537l-75.213-75.213H256z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D80027"
    },
    d: "M129.515,33.391C89.476,56.19,56.189,89.476,33.391,129.515V256h66.783V100.176v-0.002H256 c0-21.063,0-41.129,0-66.783H129.515z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D80027"
    },
    d: "M256,224.519l-90.955-90.953h-31.48v0.002L255.998,256H256C256,256,256,234.293,256,224.519z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#338AF3"
    },
    d: "M289.391,133.565v122.434c0,59.64,77.913,77.914,77.913,77.914s77.913-18.274,77.913-77.914V133.565 H289.391z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A2001D"
    },
    d: "M289.391,255.999c0,59.64,77.913,77.914,77.913,77.914s77.913-18.274,77.913-77.914H289.391z"
  }), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "400.696,189.219 378.434,189.219 378.434,166.957 356.173,166.957 356.173,189.219 333.913,189.219  333.913,211.479 356.173,211.479 356.173,278.261 378.434,278.261 378.434,211.479 400.696,211.479 "
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMs);
export default __webpack_public_path__ + "static/media/ms.7327f92cc7ceb1f530f41a539150f28b.svg";
export { ForwardRef as ReactComponent };